import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { BaseAPIService } from '../../Services/api.base.service';
import { MessageService } from 'primeng/api';
import { label } from '../../constants/labels';
import { Observable, Subscription, of, timer } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { ICommand } from '@app/Models/ICommand';
import { UtilService } from '../../Services/util.service';
import { Table } from 'primeng/table';
import { message } from '../../constants/messages';
import { IGridCols } from '../../Models/IGridCols';
import { IDropdownConfig } from '../../Models/IDeviceMetadata';
import { TelemetryService } from '../../Services/telemetry.service';
import { ExecType } from '@app/constants/enum'
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { CanComponentDeactivate } from '../../core/CanDeactivateGuard';

@Component({
  selector: 'app-telemetry-settings',
  standalone: false,
  templateUrl: './telemetry-settings.component.html',
  styleUrls: ['../telemetry.component.scss'],
  providers: [NgxIndexedDBService],
})
export class TelemetrySettingsComponent implements OnInit, CanComponentDeactivate {
  @ViewChild(('filtr')) filtr: ElementRef;
  @ViewChild('dtParam') dtParam: Table;
  @ViewChild('dtRes') dtRes: Table;
  @ViewChild('dtCom') dtCom: Table;
  resDrpdwnConfig: IDropdownConfig;
  resData: any[];
  resValue: any;
  paramertersGridCols: Array<IGridCols>;
  paramGridData: ICommand[] = [];
  resourcesGridCols: Array<IGridCols>;
  resGridData: ICommand[] = [];
  commandsGridCols: Array<IGridCols>;
  commandGridData: ICommand[] = [];
  labels: any;
  telemetryData: Array<ICommand>;
  noParamData: boolean = false;
  noResourcesData: boolean = false;
  noCommandsData: boolean = false;
  isLoading: boolean;
  awkQueue: any[] = [];
  subscription: Subscription;
  scheduledInterval: Observable<number> = timer(0, environment.commandsPollInterval);
  selectedDivId: number;
  targetSearch: string;
  isParamPagination: boolean = true;
  isResPagination: boolean = true;
  isCmdPagination: boolean = true;
  showParamfilter: boolean = false;
  showResfilter: boolean = false;
  showCmdfilter: boolean = false;
  messages: any;
  clockIconClass = "fa-clock"
  writeIconClass = "fa-pencil-alt"
  readIconClass = "fa-book"
  playIconClass = 'fa-play'
  paramdisblPag: boolean = false;
  resdisblPag: boolean = false;
  cmddisblPag: boolean = false;
  inputErrorMessages: string = ''
  currentValueValid: boolean = true;
  previousWriteVal: any
  // initalLoading: boolean;
  constructor(private dbService: NgxIndexedDBService, private readonly baseService: BaseAPIService, private readonly telemetryService: TelemetryService, private readonly messageService: MessageService, private readonly translate: TranslateService) {
    this.dbService.clear('MasterExecIds').subscribe((successDeleted) => {
      // console.log('success? ', successDeleted);
    });
  }
  ngOnDestroy() {
    this.dbService.clear('MasterExecIds').subscribe((successDeleted) => {
      // console.log('success? ', successDeleted);
    });
  }
  canDeactivate(): Observable<boolean> {
    this.dbService.clear('MasterExecIds').subscribe((successDeleted) => {
      // console.log('success? ', successDeleted);
    });
    return of(true);
  }
  ngOnInit(): void {
    // this.initalLoading = true;
    this.messages = message;
    this.labels = label;
    this.isLoading = false;
    this.resDrpdwnConfig = {
      displayKey: "value", //if objects array passed which key to be displayed defaults to description,
      search: false, //enables the search plugin to search in the list
      height: '300px'
    };
    this.paramertersGridCols = [
      { field: 'favourite', header: this.labels.favourites, width: '5%' },
      { field: 'label', header: this.labels.label, width: '10%' },
      { field: 'description', header: this.labels.dgTblHeaderDescription, width: '20%' },
      { field: 'min', header: this.labels.tableHeaderMin, width: '12%' },
      { field: 'max', header: this.labels.tableHeaderMax, width: '12%' },
      { field: 'current', header: this.labels.currentValue, width: '12%' },
      { field: 'unit', header: this.labels.unit, width: '12%' },
      { field: 'exeuteCommandId', display: 'none' },
      { field: 'id', display: 'none' }
    ];

    this.resourcesGridCols = [
      { field: 'favourite', header: this.labels.favourites, width: '5%' },
      { field: 'label', header: this.labels.label, width: '10%' },
      { field: 'description', header: this.labels.dgTblHeaderDescription, width: '10%' },
      { field: 'current', header: this.labels.currentValue, width: '15%' },
      { field: 'unit', header: this.labels.unit, width: '15%' },
      { field: 'exeuteCommandId', display: 'none' },
      { field: 'id', display: 'none' }
    ];

    this.commandsGridCols = [
      { field: 'favourite', header: this.labels.favourites, width: '5%' },
      { field: 'label', header: this.labels.label, width: '5%' },
      { field: 'description', header: this.labels.dgTblHeaderDescription, width: '20%' },
      { field: 'exeuteCommandId', display: 'none' },
      { field: 'id', display: 'none' }
    ];

    this.resData = [
      {
        key: 0,
        value: this.translate.instant(this.labels.applyToLab2)
      },
      {
        key: 1,
        value: this.translate.instant(this.labels.parameter)
      },
      {
        key: 2,
        value: this.translate.instant(this.labels.resources),
      },
      {
        key: 3,
        value: this.translate.instant(this.labels.commands)
      }
    ];
    if (window.innerWidth >= 1200) {
      this.resValue = this.resData[0].key;
    } else {
      this.resValue = this.resData[1].key;
    }

    this.GetResourcesData(this.telemetryService.cooler_mask, this.telemetryService.cooler_poli, this.telemetryService.dongleUId);
    this.subscription = this.scheduledInterval.subscribe(() => {
      this.CheckAwkReception();
    });
    if (this.targetSearch !== null) {
      setTimeout(() => {
        this.filtr.nativeElement.dispatchEvent(new Event('input'));
      }, 0);
    }
  }
  toggleParamDiv(index: number) {
    this.toogleDiv('paramDiv', index)
  }
  toggleResourceDiv(index: number) {
    this.toogleDiv('resDiv', index)
  }
  toogleDiv(section, index) {
    this.selectedDivId = index;
    const elem: Element = document.getElementById(section + index);
    elem.setAttribute("style", "display: block;");
  }
  onSettingTabChange(resData) {
    this.resValue = resData;
  }
  GetResourcesData(mask: string, poli: string, dongleUid: string) {
    this.isLoading = true;
    this.messageService.clear();
    const data = {
      'mask': mask,
      'poli': poli,
    }
    this.baseService.GET(`/DeviceSetting/DeviceSettings/${dongleUid}?${UtilService.EncodeQuery(data)}`)
      .subscribe((result: ICommand[]) => {
        this.paramGridData = [];
        this.resGridData = [];
        this.commandGridData = [];
        this.telemetryData = result;
        this.isParamPagination = false;
        this.isCmdPagination = false;
        this.isResPagination = false;
        const paramGridData = this.telemetryData.filter(item => item.resourceType === "Parameter");
        if (paramGridData.length === 0) {
          this.noParamData = true;
        }
        else {
          if (paramGridData.length > 10) {
            this.isParamPagination = true;
          }
          this.BindData(paramGridData, this.paramGridData);
        }

        //resources
        const resGridData = this.telemetryData.filter(item => item.resourceType === "Resource");
        if (resGridData.length === 0) {
          this.noResourcesData = true;
        }
        else {
          if (resGridData.length > 10) {
            this.isResPagination = true;
          }
          this.BindData(resGridData, this.resGridData);
        }

        //commands
        const commandGridData = this.telemetryData.filter(item => item.resourceType === "NetCommand");
        if (commandGridData.length === 0) {
          this.noCommandsData = true;
        }
        else {
          if (commandGridData.length > 10) {
            this.isCmdPagination = true;
          }
          this.BindData(commandGridData, this.commandGridData);
        }
        if (window.innerWidth >= 1200) {
          if (this.dtParam !== undefined) {
            this.dtParam.reset();
          }
          if (this.dtCom !== undefined) {
            this.dtCom.reset();
          }
          if (this.dtRes !== undefined) {
            this.dtRes.reset();
          }
        }
        this.isLoading = false;
        //if (this.initalLoading) {
        //  this.initalLoading = false;
        //  this.baseService.POST(`/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${this.paramGridData[0].id}?operationType=0`, {}).subscribe((response) => {
        //    //only called in intial load to check connection with dongle and cloud
        //  });
        //}

      }, (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.apiRequestProcessError, key: 'error' });
      });
  }
  public removeFavourite(resourceId: number, resName: string) {
    this.baseService.DELETE(`/DeviceSetting/UserPreferredResource/${this.telemetryService.dongleUId}/${resourceId}`, {})
      .subscribe((response: any) => {
        this.GetResourcesData(this.telemetryService.cooler_mask, this.telemetryService.cooler_poli, this.telemetryService.dongleUId);
        this.messageService.add({
          severity: 'success', summary: this.translate.instant(this.messages.success),
          detail: this.translate.instant(resName + this.messages.favouriteRemovedSuccessfuly), key: 'success'
        });

      }, (error) => {
        this.messageService.add({
          severity: 'error', summary: this.translate.instant(this.messages.error),
          detail: this.translate.instant(resName + this.messages.favouriteNotRemovedSuccessfuly), key: 'error'
        });
      });
  }
  public addFavourite(resourceId: number, resName: string) {
    this.baseService.POST(`/DeviceSetting/SetUserPreferredResource/${this.telemetryService.dongleUId}/${resourceId}`, {})
      .subscribe((response: any) => {
        this.GetResourcesData(this.telemetryService.cooler_mask, this.telemetryService.cooler_poli, this.telemetryService.dongleUId);
        this.messageService.add({
          severity: 'success', summary: this.translate.instant(this.messages.success),
          detail: this.translate.instant(resName + this.messages.favouriteAddedSuccessfuly), key: 'success'
        });

      }, (error) => {
        this.messageService.add({
          severity: 'error', summary: this.translate.instant(this.messages.error),
          detail: this.translate.instant(resName + this.messages.favouriteNotAddedSuccessfuly), key: 'error'
        });
      });
  }

  public ReadOperation(event, type: string, resourceId: number) {
    this.disablePaginationByClickType(type);
    const statusLabelElem: Element = document.getElementById(`labelRead-${resourceId}`);
    if (statusLabelElem !== null) {
      statusLabelElem.className = '';
    }
    this.AddTimerIcon(event.target, statusLabelElem);
    this.ClearGridData(resourceId, type);
    this.messageService.clear();
    this.baseService.POST(`/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${resourceId}?operationType=0`, {})
      .subscribe((response) => {
        this.disablePaginationByClickType(type);
        let exectype = null;
        switch (type) {
          case 'param':
            const idxP = this.paramGridData.findIndex(x => x.id === resourceId);
            if (idxP > -1) {
              this.paramGridData[idxP].exeuteCommandId = response.masterExecutionId;
            }
            exectype = ExecType.param;
            this.AddMasterExecIds(resourceId, response.masterExecutionId);
            break;
          case 'res':
            const idxR = this.resGridData.findIndex(x => x.id === resourceId);
            if (idxR > -1) {
              this.resGridData[idxR].exeuteCommandId = response.masterExecutionId;
            }
            exectype = ExecType.resource;
            break;
          default:
            break;
        }
        this.awkQueue.push({
          'id': event.target.id,
          'execCommId': response.masterExecutionId,
          'retries': 0,
          'resourceId': resourceId,
          'operation': 'Read',
          'exectype': exectype
        });

      }, (error) => {
        this.RemoveTimerIconOnFail(event.target, statusLabelElem);
        this.disablePagination();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.apiRequestProcessError, key: 'error' });
      });
  }


  AddMasterExecIds(resourceId: number, masterExecId: string): any {
    this.dbService.getByIndex('MasterExecIds', 'resourceId', resourceId).subscribe((data: any) => {

      if (data) {
        data.masterExecId = masterExecId;
        this.dbService.update('MasterExecIds', data).subscribe(() => {
          return 'Updated';
        });
      } else {
        const newRecord = { resourceId, masterExecId };
        this.dbService.add('MasterExecIds', newRecord).subscribe(() => {
          return 'Inserted';
        });


      }
    })
  }

  public WriteOperation(event, type: string, writeVal: any, resourceId: number, unit: any, min: any, max: any) {
    this.disablePaginationByClickType(type)
    this.messageService.clear();
    if (type === 'param') {
      if (writeVal === null) {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: this.messages.readValueFirst, key: 'warn' });
        this.disablePagination();
        return;
      }
      if (!this.validateValue(writeVal, resourceId, unit, min, max)) { return }
    }
    if (writeVal !== null) { // writevalues will be null for command type
      if (type === 'param' && unit.toLowerCase() === 'flag') {
        if (writeVal.toLowerCase() == 'true') {
          writeVal = 1
        } else if (writeVal.toLowerCase() == 'false') {
          writeVal = 0
        }
      }
    }
    const statusLabelElem: Element = document.getElementById(`labelWrite-${resourceId}`);
    if (statusLabelElem !== null) {
      statusLabelElem.className = '';
    }

    this.AddTimerIcon(event.target, statusLabelElem);
    let url = '';
    switch (type) {
      case 'comm':
        url = `/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${resourceId}?operationType=2`;
        this.writeApiCall(url, type, resourceId, event, statusLabelElem);
        break;
      case 'res':
        url = (writeVal === null || typeof (writeVal) === 'undefined')
          ? `/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${resourceId}?operationType=0`
          : `/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${resourceId}?operationType=1&writeVal=${writeVal}`;
        this.writeApiCall(url, type, resourceId, event, statusLabelElem)
        break;
      case 'param':
        this.dbService.getByIndex('MasterExecIds', 'resourceId', resourceId).subscribe((data: any) => {
          if (data) {
            const indexDb_masterExecId = data.masterExecId;
            url = (writeVal === null || typeof (writeVal) === 'undefined')
              ? `/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${resourceId}?operationType=0&readCmdMasterExecId=${indexDb_masterExecId}`
              : `/Command/ExecuteMasterCommand/${this.telemetryService.dongleUId}/${resourceId}?operationType=1&writeVal=${writeVal}&readCmdMasterExecId=${indexDb_masterExecId}`;
            this.writeApiCall(url, type, resourceId, event, statusLabelElem);
          }
        });
        break;
      default:
        break;
    }

  }
  private writeApiCall(url, type, resourceId, event, statusLabelElem) {
    this.baseService.POST(url, {})
      .subscribe((response) => {
        this.disablePaginationByClickType(type)
        let exectype = null;
        switch (type) {
          case 'comm':
            exectype = ExecType.command;
            const idxC = this.commandGridData.findIndex(x => x.id === resourceId);
            if (idxC > -1) {
              this.commandGridData[idxC].exeuteCommandId = response.masterExecutionId;
            }
            break;
          case 'res':
            exectype = ExecType.resource;
            const idxR = this.resGridData.findIndex(x => x.id === resourceId);
            if (idxR > -1) {
              this.resGridData[idxR].exeuteCommandId = response.masterExecutionId;
            }
            break;
          case 'param':
            exectype = ExecType.param;
            const idxP = this.paramGridData.findIndex(x => x.id === resourceId);
            if (idxP > -1) {
              this.paramGridData[idxP].exeuteCommandId = response.masterExecutionId;
            }
            break;
          default:
            break;
        }
        this.awkQueue.push({
          'id': event.target.id,
          'execCommId': response.masterExecutionId,
          'retries': 0,
          'resourceId': resourceId,
          'operation': 'Write',
          'exectype': exectype
        });

      }, (error) => {
        this.RemoveTimerIconOnFail(event.target, statusLabelElem);
        this.disablePagination();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.apiRequestProcessError, key: 'error' });
      });
  }
  private BindData(source: ICommand[], destination: ICommand[]) {
    source.forEach(element => {
      destination.push({
        label: element.label || null,
        description: element.description || null,
        current: element.current || null,
        min: element.min || null,
        max: element.max || null,
        unit: element.unit || null,
        id: element.id || null,
        exeuteCommandId: element.exeuteCommandId || null,
        favourite: element.favourite || false
      });
    });
  }

  private ProcessAwk(awk: {}) {
    this.messageService.clear();
    const statusLabelElem: Element = document.getElementById(`label${awk['operation']}-${awk['resourceId']}`);
    const span = document.querySelector(`#${awk['id']}`);
    this.baseService.GET(`/DeviceSetting/CommandResultResponse/${awk['execCommId']}`, {})
      .subscribe((response: any) => {
        if (response !== null) {
          this.SuccessIcon(span, awk, response, statusLabelElem);
          if (this.awkQueue.findIndex(a => a.execCommId === awk['execCommId']) != -1) {
            this.awkQueue.splice(this.awkQueue.findIndex(a => a.execCommId === awk['execCommId']), 1);
          }
          this.disablePagination();
        }
        else if (awk['retries'] >= 3) {
          this.FailedIcon(span, awk, statusLabelElem);
          if (this.awkQueue.findIndex(a => a.execCommId === awk['execCommId']) != -1) {
            this.awkQueue.splice(this.awkQueue.findIndex(a => a.execCommId === awk['execCommId']), 1);
          }
          this.messageService.add({ severity: 'warn', summary: 'Warning', detail: this.messages.noResponseFromDevice, key: 'warn' });
          this.disablePagination();
        }
        else {
          console.info(`No AWK response received for: ${awk['execCommId']}`);
        }
      }, (error) => {
        if (awk['retries'] >= 3) {
          this.FailedIcon(span, awk, statusLabelElem);
          if (this.awkQueue.findIndex(a => a.execCommId === awk['execCommId']) != -1) {
            this.awkQueue.splice(this.awkQueue.findIndex(a => a.execCommId === awk['execCommId']), 1);
          }
          this.disablePagination();
          switch (error.status) {
            case 204:
              this.messageService.add({ severity: 'warn', summary: 'Warning', detail: this.messages.noResponseFromDevice, key: 'warn' });
              break
            case 400:
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.badRequest, key: 'error' });
              break;
            case 500:
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.apiRequestProcessError, key: 'error' });
              break;
            default:
              this.messageService.add({ severity: 'error', summary: 'Error', detail: this.messages.apiRequestProcessError, key: 'error' });
              break;
          }
        }
      });
  }

  private ClearGridData(rowId, type) {
    let idx: any = null;
    if (type === 'param') {
      idx = this.paramGridData.findIndex(x => x.id === rowId);
      if (idx > -1) {
        this.paramGridData[idx].min = null;
        this.paramGridData[idx].max = null;
        this.paramGridData[idx].current = null;
        this.paramGridData[idx].unit = null;
      }
      const errorLabelElem: Element = document.getElementById(`param-error-${rowId}`);
      const writeElem: Element = document.getElementById(`param-w-${rowId}`);
      if (errorLabelElem.classList.contains('error-Message')) { errorLabelElem.classList.remove('error-Message'); }
      errorLabelElem.classList.add('hide');
      const currentWriteElem: Element = document.getElementById(`param-current-${rowId}`);
      if (currentWriteElem != null && currentWriteElem.classList.contains('error-border')) { currentWriteElem.classList.remove('error-border'); }
      writeElem.classList.add('display-inline-block');
      if (writeElem.classList.contains('hide')) { writeElem.classList.remove('hide'); }
    } else if (type === 'res') {
      idx = this.resGridData.findIndex(x => x.id === rowId);
      if (idx > -1) {
        this.resGridData[idx].current = null;
        this.resGridData[idx].unit = null;
      }
    }
  }
  private UpdateGridData(data: any) {
    let row = this.awkQueue.find(x => x.execCommId === data.masterExecutionId);
    if (row != undefined) {
      const type = (row.id).split('-')[0];
      let idx = 0;
      if (type === 'param') {
        idx = this.paramGridData.findIndex(x => x.exeuteCommandId === data.masterExecutionId);
        if (idx > -1) {
          this.paramGridData[idx].min = data.minVal;
          this.paramGridData[idx].max = data.maxVal;
          this.paramGridData[idx].current = data.currentVal;
          this.paramGridData[idx].unit = data.unit;
        }

      }
      if (type === 'res') {
        idx = this.resGridData.findIndex(x => x.exeuteCommandId === data.masterExecutionId);
        if (idx > -1) {
          this.resGridData[idx].current = data.currentVal;
          this.resGridData[idx].unit = data.unit;
        }

      }
      if (type === 'comm') {
        idx = this.commandGridData.findIndex(x => x.exeuteCommandId === data.masterExecutionId);
        if (idx > -1) {
          this.commandGridData[idx].min = data.minVal;
          this.commandGridData[idx].max = data.maxVal;
          this.commandGridData[idx].current = data.currentVal;
          this.commandGridData[idx].unit = data.unit;
        }

      }
    }
  }

  private disablePaginationByClickType(type) {
    switch (type) {
      case 'comm':
        if (!this.cmddisblPag) {
          Array.from(document.querySelectorAll(".tbl-commd .p-paginator-element")).forEach((element, index) => {
            element.classList.add('p-disabled');
            this.cmddisblPag = true;
          });
        }
        break;
      case 'res':
        if (!this.resdisblPag) {
          Array.from(document.querySelectorAll(".tbl-resources .p-paginator-element")).forEach((element, index) => {
            element.classList.add('p-disabled');
            this.resdisblPag = true
          });
        }
        break;
      case 'param':
        if (!this.paramdisblPag) {
          Array.from(document.querySelectorAll(".tbl-param .p-paginator-element")).forEach((element, index) => {
            element.classList.add('p-disabled');
            this.paramdisblPag = true;
          });
        }
        break;
      default:
        break;
    }
  }

  private disablePagination() {
    //param = 0,
    //  command = 1,
    //  resource = 2

    let paramReq = this.awkQueue.find(elem => elem.exectype === 0);

    Array.from(document.querySelectorAll(".tbl-param .p-paginator-element")).forEach((element, index) => {
      if (paramReq != undefined) {
        element.classList.add('p-disabled');
        this.paramdisblPag = true;
      } else {
        element.classList.remove('p-disabled');
        this.paramdisblPag = false;
      }
    });

    let commReq = this.awkQueue.find(elem => elem.exectype == 1);

    Array.from(document.querySelectorAll(".tbl-commd .p-paginator-element")).forEach((element, index) => {
      if (commReq != undefined) {
        element.classList.add('p-disabled');
        this.cmddisblPag = true;
      } else {
        element.classList.remove('p-disabled');
        this.cmddisblPag = false;
      }
    });
    let resReq = this.awkQueue.find(elem => elem.exectype == 2);
    Array.from(document.querySelectorAll(".tbl-resources .p-paginator-element")).forEach((element, index) => {
      if (resReq != undefined) {
        element.classList.add('p-disabled');
        this.resdisblPag = true;
      } else {
        element.classList.remove('p-disabled');
        this.resdisblPag = false;
      }
    });
  }

  private CheckAwkReception() {
    if (this.awkQueue.length > 0) {
      this.awkQueue.forEach(element => {
        element.retries += 1;
        this.ProcessAwk(element);
      });
    }

  }

  private AddTimerIcon(target: any, statusLabelElem: any) {
    if (target == null) { return; }
    if (window.innerWidth >= 1200) {
      if (target.classList.contains(this.readIconClass)) {
        target.classList.remove(this.readIconClass);
      }
      if (target.classList.contains(this.writeIconClass)) {
        target.classList.remove(this.writeIconClass);
      }
      if (target.classList.contains(this.playIconClass)) {
        target.classList.remove(this.playIconClass);
      }

      target.classList.add(this.clockIconClass);
    } else if (statusLabelElem !== null && window.innerWidth <= 1200) {
      statusLabelElem.textContent = this.translate.instant(this.labels.processing);
      statusLabelElem.classList = " ";
      statusLabelElem.classList.add("processing-message");
      this.fadeOutRequestStatus(statusLabelElem);
    } else {
      //empty condition block
    }
  }

  private RemoveTimerIconOnFail(target: any, statusLabelElem: any) {
    if (target == null) { return; }
    if (window.innerWidth >= 1200) {
      target.classList.add("fail");
      window.setTimeout(() => {
        target.classList.remove("fail");
        target.classList.remove(this.clockIconClass);
        if (target.id.includes("param-w")) {
          target.classList.add(this.writeIconClass);
        }
        else if (target.id.includes("param") || target.id.includes("res")) {
          target.classList.add(this.readIconClass);
        }
        else {
          target.classList.add(this.playIconClass);
        }

      }, 2000);
    } else {
      if (statusLabelElem !== null && window.innerWidth <= 1200) {
        statusLabelElem.textContent = this.translate.instant(this.labels.fail);
        statusLabelElem.classList = " ";
        statusLabelElem.classList.add("error-message");
        this.fadeOutRequestStatus(statusLabelElem);
      }
    }
  }

  private SuccessIcon(span: any, awk: {}, response: any, statusLabelElem: any) {
    if (span == null) { return; }
    if (window.innerWidth >= 1200) {
      if (span.classList.contains(this.clockIconClass)) {
        span.classList.remove(this.clockIconClass);
        if (awk['id'].includes('param-w')) {
          span.classList.add(this.writeIconClass);
        }
        else if (awk['id'].includes('param')) {
          span.classList.add(this.readIconClass);
        }
        else if (awk['id'].includes('res')) {
          span.classList.add(this.readIconClass);
        }
        else if (awk['id'].includes('comm')) {
          span.classList.add("fa-play");
        }
        else {
          //empty condition block
        }
        span.classList.add("success");
        if (!(awk['id'].includes('comm-w') || awk['id'].includes('param-w'))) {
          this.UpdateGridData(response);
        }
        window.setTimeout(() => {
          span.classList.remove('success');
        }, 2000);
      }
    } else {
      if (statusLabelElem !== null) {
        statusLabelElem.textContent = this.translate.instant(this.labels.success);
        statusLabelElem.classList = " ";
        statusLabelElem.classList = "sucess-message";
        if (!(awk['id'].includes('comm-w') || awk['id'].includes('param-w'))) {
          this.UpdateGridData(response);
        }
        this.fadeOutRequestStatus(statusLabelElem);
      }
    }
  }

  private FailedIcon(span: any, awk: {}, statusLabelElem: any) {
    if (span == null) { return; }
    if (window.innerWidth >= 1200) {
      if (span.classList.contains(this.clockIconClass)) {
        span.classList.remove(this.clockIconClass);
        if (awk['id'].includes('comm-w')) {
          span.classList.add(this.playIconClass);
        }
        else if (awk['id'].includes('param-w')) {
          span.classList.add(this.writeIconClass);
        }
        else {
          span.classList.add(this.readIconClass);
        }

        span.classList.add("fail");
        window.setTimeout(() => {
          span.classList.remove('fail');
        }, 2000);
      }
    } else {
      if (statusLabelElem !== null) {
        statusLabelElem.textContent = this.translate.instant(this.labels.fail);
        statusLabelElem.classList = " ";
        statusLabelElem.classList.add("error-message");
        this.fadeOutRequestStatus(statusLabelElem);
      }
    }
  }
  fadeOutRequestStatus(statusLabelElem: any) {
    if (statusLabelElem == null) { return; }
    setTimeout(function () {
      statusLabelElem.textContent = " ";
      statusLabelElem.classList = " ";
    }, 10000);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth >= 1200) {
      this.resValue = this.resData[0].key;
    } else {
      this.resValue = this.resData[1].key;
    }
  }
  public ToggleFilter(table: any, filter: string) {
    if (filter === "param") {
      this.showParamfilter = !this.showParamfilter;
    } else if (filter === "res") {
      this.showResfilter = !this.showResfilter;
    } else if (filter === "cmd") {
      this.showCmdfilter = !this.showCmdfilter;
    } else {
      //empty condition block
    }
    if (!this.showParamfilter || !this.showResfilter || !this.showCmdfilter) {
      table.reset();
    }
  }

  validateValue(writeVal, id, unit, min, max) {
    const writeCurrentElem: Element = document.getElementById(`param-current-${id}`);
    const writeElem: Element = document.getElementById(`param-w-${id}`);
    this.inputErrorMessages = '';
    this.currentValueValid = true;
    const errorLabelElem: Element = document.getElementById(`param-error-${id}`);

    if (writeVal == "") {
      writeCurrentElem.innerHTML = 'null'
      writeCurrentElem.classList.add('error-border');
      this.inputErrorMessages = this.messages.valueRequired;
      this.currentValueValid = false;
    } else {
      if (writeCurrentElem != null && writeCurrentElem.classList.contains('error-border')) { writeCurrentElem.classList.remove('error-border'); }
      if (unit.toLowerCase() === 'flag') {
        if (writeVal.toLowerCase() != 'true' && writeVal.toLowerCase() != 'false' && writeVal != '1' && writeVal != '0') {
          this.currentValueValid = false;
          this.inputErrorMessages = this.messages.currentValInvalidBool
        }
      }
      else {
        if (isNaN(Number(writeVal))) {
          this.inputErrorMessages = this.messages.currentValInvalid;
          this.currentValueValid = false;
        }
        if (writeVal.toString().indexOf('.') !== -1 && writeVal.toString().split('.').length > 2) {
          this.inputErrorMessages = this.messages.currentValInvalid
          this.currentValueValid = false;
        }
        if (writeVal.toString().indexOf(',') !== -1 && writeVal.toString().split(',').length > 2) {
          this.inputErrorMessages = this.messages.currentValInvalid
          this.currentValueValid = false;
        }
        else {
          writeVal = Number(writeVal.toString().replace(',', '.'));
          if (min != null && max != null) {
            if (min > writeVal || writeVal > max) {
              this.inputErrorMessages = this.messages.currentValInvalidMinMax.replace("{min}", min).replace("{max}", max)
              this.currentValueValid = false;
            }
          } else if (min == null) {
            if (writeVal > max) {
              this.inputErrorMessages = this.messages.currentValInvalidMax.replace("{max}", max)
              this.currentValueValid = false;
            }
          } else if (max == null) {
            if (min > writeVal) {
              this.inputErrorMessages = this.messages.currentValInvalidMin.replace("{min}", min)
              this.currentValueValid = false;
            }
          }
        }
      }
    }
    if (this.currentValueValid) {

      if (errorLabelElem.classList.contains('error-Message')) { errorLabelElem.classList.remove('error-Message'); }
      if (writeCurrentElem != null && writeCurrentElem.classList.contains('error-border')) { writeCurrentElem.classList.remove('error-border'); }
      errorLabelElem.classList.add('hide');
      writeElem.classList.add('display-inline-block');
      if (writeElem.classList.contains('hide')) { writeElem.classList.remove('hide'); }
      return true;
    } else {
      if (writeElem.classList.contains('display-inline-block')) { writeElem.classList.remove('display-inline-block'); }
      writeElem.classList.add('hide');
      errorLabelElem.classList.add('error-Message');
      if (writeCurrentElem != null) { writeCurrentElem.classList.add('error-border'); }
      errorLabelElem.innerHTML = this.inputErrorMessages;
      if (errorLabelElem.classList.contains('hide')) { errorLabelElem.classList.remove('hide'); }
      return false;
    }
  }
}



